const selectors = {
  slideButtons: document.querySelectorAll('[data-slide-button]'),
};

const collectionPage = {
  init: () => {
    [...selectors.slideButtons].forEach((button) => {
      button.addEventListener('click', () => {
        const parent = button.closest('[data-slide-buttons-parent]');
        const buttonDirection = button.dataset.slideButton;
        const flickityButton = parent.querySelector(`.flickity-button.${buttonDirection}`);
        flickityButton.click();
      });
    });
  },
};

collectionPage.init();

export default collectionPage;
